import { Component, computed, effect, inject, input } from '@angular/core';
import { TariffOptionSap, TariffSelectionCardData } from '@mwe/models';
import { TariffSelectionCardLogic } from '../services/tariff-selection-card.logic';
import { TariffSelectionStore } from '../services/tariff-selection.store';
import { TariffSelectionCardUiComponent } from './tariff-selection-card-ui.component';

@Component({
  selector: 'mwe-tariff-selection-card-store',
  templateUrl: './tariff-selection-card-store.component.html',
  imports: [TariffSelectionCardUiComponent],
})
export class TariffSelectionCardStoreComponent {
  private readonly cardLogic = inject(TariffSelectionCardLogic);
  private readonly store = inject(TariffSelectionStore);

  readonly hasActions = input<boolean>();
  readonly isReadonly = input<boolean>();
  readonly lockedGroupIds = input<string[]>([]);
  readonly tariff = input<TariffSelectionCardData>(); // data comes from signal() do not manipulate it!!!! notify parent and parent should change it in TariffSelectionStore
  readonly hasNewVoucher = input<boolean>(false); // changes how API calls are done, should only be used in conjunction with NewVoucherFormComponent
  readonly reloadHandler = input<(tariff: TariffSelectionCardData) => void>();

  readonly additionalOptionGroupName = computed<string>(() => this.store.additionalOptionGroupName());
  readonly processType = computed(() => this.store.processType());

  constructor() {
    effect(() => {
      if (!this.hasNewVoucher()) return;
      const tariff = this.tariff();

      if (tariff.state === 'success') this.store.updateSelectedTariffsForNewVoucherCategory(tariff);
    });
  }

  onTariffUpdated(data: TariffOptionSap): void {
    if (this.hasNewVoucher()) {
      this.store.updateSelectedTariffsForNewVoucher(this.tariff(), data);
      return;
    }

    this.cardLogic.handleTariffOptionChange(this.tariff(), data);
  }

  onReloadAfterError(): void {
    if (this.reloadHandler()) {
      this.reloadHandler()(this.tariff());
      return;
    }

    // retry with old state
    this.cardLogic.handleTariffOptionChange(this.tariff(), this.tariff().userSelection[0]);
  }
}
